import Modal, { ModalProps } from './Modal'
export { Modal }
export type { ModalProps }
export default Modal
